function initScrollingSplide(container) {
  if (!container) return;

  if (container.__splideInstance) {
    container.__splideInstance.destroy(true);
  }

  const isEditor = Shopify && Shopify.designMode;

  const splide = new Splide(container, {
    type: "loop",
    drag: !isEditor,
    arrows: false,
    pagination: false,
    autoWidth: true,
    gap: 0,
    autoScroll:{
      speed: Number(container.getAttribute("data-scrolling-speed")) || 1.2,
    }
  });

  splide.mount(window.splide.Extensions);
  container.__splideInstance = splide;
}

document.addEventListener("DOMContentLoaded", () => {
  const container = document.querySelector(".js-scrolling-splide");
  if (container) initScrollingSplide(container);
});

document.addEventListener("shopify:section:load", (e) => {
  const container = e.target.querySelector(".js-scrolling-splide");
  if (container) initScrollingSplide(container);
});

document.addEventListener("shopify:block:select", (e) => {
  const container = e.target.closest(".shopify-section")
    ?.querySelector(".js-scrolling-splide");
  if (container) initScrollingSplide(container);
});

document.addEventListener("shopify:block:deselect", (e) => {
  const container = e.target.closest(".shopify-section")
    ?.querySelector(".js-scrolling-splide");
  if (container) initScrollingSplide(container);
});